import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { StorageService } from '../storage/storage.service';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  socket$: WebSocketSubject<any>;
  socket2$: WebSocketSubject<any>;
  // user_id: any;
  chatMessages$: Observable<any>;
  chatMessages2$: Observable<any>;
  participantUrl: WebSocketSubject<any>;
  participantList$: any;
  send_file_Url: any;
  role: any;
  role_assignment: any;

  constructor(public storageService: StorageService) {
    // this.user_id = localStorage.getItem('user_id');
    // this.user_id = this.role.id;
    // this.user_id = this.role.role;
    // if(this.role){
    //   this.displayChat();
    //   // this.assigningRole();
    // }
  }

  assigningRole() {
    this.role_assignment = this.role.role.group.category;
    return this.role_assignment;
  }

  getMessageHistory(receiverId: number, page): Observable<any> {
    const user_id = this.storageService.get('user_details').id;
    this.socket$ = webSocket(
      environment.chat_apiEndpoint + `/ws/singlechat/${user_id}/${receiverId}/`,
    );
    this.chatMessages$ = this.socket$.asObservable();
    this.socket$.next({ command: 'fetch_messages', page: page });
    return this.chatMessages$;
  }

  getMessageHistory2(receiverId: number, page): Observable<any> {
    const user_id = this.storageService.get('user_details').id;
    this.socket2$ = webSocket(
      environment.chat_apiEndpoint + `/ws/singlechat/${user_id}/${receiverId}/`,
    );
    this.chatMessages2$ = this.socket2$.asObservable();
    this.socket2$.next({ command: 'fetch_messages', page: page });
    return this.chatMessages2$;
  }

  sendMessage(message: any) {
    this.socket$.next(message);
  }

  sendMessage2(message: any) {
    this.socket2$.next(message);
  }

  closeConnection() {
    this.socket$.complete();
  }

  closeConnection2() {
    this.socket2$.complete();
  }

  displayChat(): Observable<any> {
    const user_id = this.storageService.get('user_details').id;
    // this.participantUrl = webSocket(`wss://wealth.cognerium.com:8004/ws/chatoperations/${user_id}/`);
    this.participantUrl = webSocket(
      environment.chat_apiEndpoint + `/ws/chatoperations/${user_id}/`,
    );
    this.participantList$ = this.participantUrl.asObservable();
    // setInterval(()=>{
    this.participantUrl.next({ command: 'display_chat' });
    // },3000);
    return this.participantList$;
  }

  closeDisplayChat() {
    this.participantUrl.complete();
  }
}
